export enum ContainerNames {
    Images = 'images',
    WorkOrders = 'work-order',
    KYC = 'kyc'
}